module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "artist-card"
  }, [_c('v-flex', {
    staticClass: "item-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "artist-info-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "artist-cover",
    style: ({
      'background-image': 'url(' + _vm.artist.avatar.url + ')'
    })
  }), _vm._v(" "), (_vm.canViewProfile) ? _c('v-flex', {
    staticClass: "artist-actions",
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.artist.slug))
    }
  }), _vm._v(" "), (_vm.followButtonVisible) ? _c('div', {
    staticClass: "follow-section"
  }, [_c('user-follow-btn', {
    staticClass: "mt-3",
    attrs: {
      "user": _vm.artist,
      "type": "default"
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_vm._v("\n        " + _vm._s(_vm.artist.username) + "\n        "), (_vm.artist.user_type !== 'listener') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.artist.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "artist-title"
  }, [_vm._v("\n        Artist\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-221948b9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/artistitem.vue
// module id = 1650
// module chunks = 180